import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FleetStateService {

  private readonly fleetIdSubject = new BehaviorSubject<string[]>([]);
  fleetId$ = this.fleetIdSubject.asObservable();

  setFleetId(fleetId: string[]) {
    this.fleetIdSubject.next(fleetId);
  }

  getFleetId(): string[] {
    return this.fleetIdSubject.getValue();
  }
}
